import IntegrationCallResourceModel from '../../generated/types/model/resource/IntegrationCallResourceModel';

export default class IntegrationCallResourceViewModel extends IntegrationCallResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
